// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3BEx2","location":"Header_location__rxRm_"};